import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Fab, Grid, Icon, ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { useTranslation } from 'react-i18next';

import ContextMenu from 'app/components/ContextMenu';
import { hasAtLeastStarted } from 'app/containers/AWPM-FWPM/ModuleSelections/helper';
import { ModuleSelection } from 'app/containers/AWPM-FWPM/ModuleSelections/models';
import { translations } from 'locales/i18n';

interface ModuleControlButtonProps {
  menuOpen: boolean;
  anchorRef: React.MutableRefObject<null>;
  setEditModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setChangeStateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleChangeIsTakingPlace: Function;
  setIsNotTakingPlaceModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isTakingPlace?: boolean;
  isActive?: boolean;
  isDefault?: boolean;
  selection?: ModuleSelection;
}

export const ControlButtons = ({
  menuOpen,
  setMenuOpen,
  anchorRef,
  setEditModalOpen,
  setDeleteModalOpen,
  setChangeStateModalOpen,
  handleChangeIsTakingPlace,
  setIsNotTakingPlaceModalOpen,
  isTakingPlace,
  isActive,
  isDefault,
  selection
}: ModuleControlButtonProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Fab
        className="action"
        onClick={e => {
          setMenuOpen(true);
          e.stopPropagation();
          e.preventDefault();
        }}
        ref={anchorRef}
        size="small"
        style={{ zIndex: 222 }}
      >
        <Icon
          className="fas fa-ellipsis-h fa-lg"
          style={{
            width: '1em',
            color: 'black'
          }}
        />
      </Fab>
      <ContextMenu
        className="module__controls"
        open={menuOpen}
        setOpen={setMenuOpen}
        anchorEl={anchorRef.current}
        sx={{ '& .MuiList-root': { paddingRight: '8px' } }}
      >
        <MenuItem className="module__controls__container">
          <Grid
            container
            className="module__controls__container"
            onClick={e => {
              setEditModalOpen(true);
              setMenuOpen(false);
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Grid className="module__header__controls__container__icon" item xs={3}>
              <ListItemIcon>
                <Icon
                  className="fa fa-pen fa-sm"
                  style={{
                    width: 'auto',
                    color: 'lightblue',
                    fontSize: '1.1em'
                  }}
                />
              </ListItemIcon>
            </Grid>
            <Grid className="module__header__controls__container" item xs={9}>
              <ListItemText primary={t(translations.common.edit())} />
            </Grid>
          </Grid>
        </MenuItem>
        {isDefault ? (
          <MenuItem className="module__header__controls__container">
            {isActive ? (
              <Grid
                container
                className="module__header__controls__container"
                onClick={e => {
                  setChangeStateModalOpen(true);
                  setMenuOpen(false);
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <Grid className="module__header__controls__container__icon" item xs={3}>
                  <ListItemIcon>
                    <DoDisturbAltIcon
                      style={{
                        width: 'auto',
                        color: 'grey',
                        fontSize: '1.1em'
                      }}
                    />
                  </ListItemIcon>
                </Grid>
                <Grid item xs={9}>
                  <ListItemText primary={t(translations.pages.modules.deactivate())} />
                </Grid>
              </Grid>
            ) : (
              <Grid
                container
                className="module__header__controls__container"
                onClick={e => {
                  setChangeStateModalOpen(true);
                  setMenuOpen(false);
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <Grid className="module__header__controls__container__icon" item xs={3}>
                  <ListItemIcon>
                    <RadioButtonCheckedIcon
                      style={{
                        width: 'auto',
                        color: 'green',
                        fontSize: '1.1em'
                      }}
                    />
                  </ListItemIcon>
                </Grid>
                <Grid item xs={9}>
                  <ListItemText primary={t(translations.pages.modules.activate())} />
                </Grid>
              </Grid>
            )}
          </MenuItem>
        ) : !!isTakingPlace ? (
          <MenuItem className="module__header__contorls__container">
            <Grid
              container
              className="module__header__controls__container"
              onClick={e => {
                setIsNotTakingPlaceModalOpen(true);
                setMenuOpen(false);
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <Grid className="module__header__controls__container__icon" item xs={3}>
                <ListItemIcon>
                  <RemoveCircleOutlineIcon
                    style={{
                      width: 'auto',
                      color: '#e8ca23',
                      fontSize: '1.1em'
                    }}
                  />
                </ListItemIcon>
              </Grid>
              <Grid item xs={9}>
                <ListItemText primary={t(translations.pages.modules.isNotTakingPlaceButton())} />
              </Grid>
            </Grid>
          </MenuItem>
        ) : (
          <MenuItem className="module__header__contorls__container">
            <Grid
              container
              className="module__header__controls__container"
              onClick={e => {
                handleChangeIsTakingPlace(true);
                setMenuOpen(false);
                e.stopPropagation();
                e.preventDefault();
              }}
            >
              <Grid className="module__header__controls__container__icon" item xs={3}>
                <ListItemIcon>
                  <CheckCircleOutlineIcon
                    style={{
                      width: 'auto',
                      color: 'green',
                      fontSize: '1.1em'
                    }}
                  />
                </ListItemIcon>
              </Grid>
              <Grid item xs={9}>
                <ListItemText primary={t(translations.pages.modules.takesPlaceButton())} />
              </Grid>
            </Grid>
          </MenuItem>
        )}
        <MenuItem
          className="module__header__controls__container"
          disabled={selection ? hasAtLeastStarted(selection) : false}
        >
          <Grid
            container
            className="module__header__controls__container"
            onClick={e => {
              setDeleteModalOpen(true);
              setMenuOpen(false);
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <Grid className="module__header__controls__container__icon" item xs={3}>
              <ListItemIcon>
                <Icon
                  className="far fa-trash-alt fa-sm "
                  style={{
                    width: 'auto',
                    color: 'red',
                    fontSize: '1.1em'
                  }}
                />
              </ListItemIcon>
            </Grid>
            <Grid item xs={9}>
              <ListItemText primary={t(translations.common.delete())} />
            </Grid>
          </Grid>
        </MenuItem>
      </ContextMenu>
    </>
  );
};
